import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss', '../input.scss']
})
export class InputRadioComponent {
  
  @Input() 
  public label: string = "Test";

  @Input()
  public inputValue: boolean = false;

  @Output() save = new EventEmitter();

  constructor() {
    console.log(this.inputValue)
  }

  emit () {
    this.inputValue = !this.inputValue;
    this.save.emit(this.inputValue);
  }
}
